import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

type ToggleSwitchProps = {
	currentCountry: string;
	onChange: () => void;
	leftText: string;
	rightText: string;
};

const toggleButtonStyles = {
	border: "none",
	paddingLeft: "15px",
	paddingRight: "15px",
	height: "35px",
	backgroundColor: "#e0e0e0",
	color: "#757575",
	fontWeight: "normal",
	textTransform: "none" as const,
	"&.Mui-selected": {
		backgroundColor: "#ffec0f",
		color: "#000000",
		fontWeight: "bold",
		"&:hover": {
			backgroundColor: "#ffec0f",
		},
	},
	"&:hover": {
		backgroundColor: "#d5d5d5",
	},
};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
	currentCountry,
	onChange,
	leftText,
	rightText,
}: ToggleSwitchProps) => {
	const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
		if (newValue !== null && newValue !== currentCountry) {
			onChange();
		}
	};

	return (
		<ToggleButtonGroup
			value={currentCountry}
			exclusive
			onChange={handleChange}
			aria-label="Tenant Country"
			sx={{
				"& .MuiToggleButtonGroup-grouped": {
					"&:first-of-type": {
						borderTopLeftRadius: "5px",
						borderBottomLeftRadius: "5px",
					},
					"&:last-of-type": {
						borderTopRightRadius: "5px",
						borderBottomRightRadius: "5px",
					},
				},
			}}
		>
			<ToggleButton value={leftText} sx={toggleButtonStyles}>
				{leftText}
			</ToggleButton>
			<ToggleButton value={rightText} sx={toggleButtonStyles}>
				{rightText}
			</ToggleButton>
		</ToggleButtonGroup>
	);
};

export default ToggleSwitch;
